import Vue from "vue"
import router, { asyncRouterMapTFT } from "./router";
import store from "./store";
import util from "./utils/util"
import NProgress from 'nprogress'
import Cookies from "js-cookie";
import { UNION_PAY_AUTH_FLAG, UPDATE_ROLES, UPDATE_TOKEN} from "./store/modules/consts"; // Progress 进度条

/**
 * 授权鉴权:
 */
// register global progress.
// 不重定向白名单
const whiteList = ['/auth', '/login', '/noPermission', '/authredirect', '/401', '/404', '/500', '/flypigvalidate', '/flypigdetail', '/flypigorder'];
router.beforeEach((to, from, next) => {
  // 开启Progress
  NProgress.start();

  //判断是否在云闪付APP内
  let isInsideWallet = util.isUnionPay();
  let params = "";
  // 默认授权验证
  if (isInsideWallet) {
    /**
     * 云闪付正式地址（勿动）
     */
    if (to.query.bid === "Num10359") {
      //  云南云闪付佳之易数娱正式地址（勿动）
      params = "?BusinessID=Num10359&Data=lzEjC98OAgHTCRd7%2FYTT7aQnI31YuHcjvZVROtokEg2KQN8AOxe9gCoKCODUCcP2wjAMGVNJwQd%2Bi5WdLrpJOjcaedJDe9NlLoZz67LwESJpuS6apxhxvfQgqnoai2mmYnagSeijJvcOkhD6kszRQZhrZ4DsJ6CTGz2AWdrQcpkCJPeqktV2WA%3D%3D";
    } else if (to.query.bid === "Num10356") {
      // 陕西云闪付测试环境地址
      params = "?BusinessID=Num10356&Data=BXTj83DQ%2BIia7oBThcANZqc2f79lymN%2Bc290nrUBtr2tsyiXsMO70mihLeudUNFykfT6KxQsFKyTMO%2BywkXrrD6Bm%2Bi8VuEyV1TOQB6iTBq4%2F2EPIzpjVX5KZ%2F6tvWRU9v4IqkObf%2F5jbDojCl98BgYCYZUCdrILQKziktb1I0tNaMCZCMo14A%3D%3D";
    } else {
       // 陕西云闪付测试环境地址
      params = "?BusinessID=Num10356&Data=BXTj83DQ%2BIia7oBThcANZqc2f79lymN%2Bc290nrUBtr2tsyiXsMO70mihLeudUNFykfT6KxQsFKyTMO%2BywkXrrD6Bm%2Bi8VuEyV1TOQB6iTBq4%2F2EPIzpjVX5KZ%2F6tvWRU9v4IqkObf%2F5jbDojCl98BgYCYZUCdrILQKziktb1I0tNaMCZCMo14A%3D%3D";
    }
  } else {
    params = "?BusinessID=Num10354&Data=KHpf2%2BgeF8ThPE5qBwBrP5oOIjt87w7I0WKTCUpPeRgFmAYDn55GNmF1GGFJkiIirJtnUhAbFZR303gwrwMhJTPwZMtsVN%2Bv64P7TLY7IxbGNr2zACz1gwWatrZR2ma4Dw4quwVO%2Bg3Hrnuh2qmnylMg34HU4tHV5DMCnZkMIseXXGnTa%2BJtBA%3D%3D";
  }

  //  打开授权授权页时，进行授权验证
  if (to.path === '/auth') {
    // 情况1：当 URL 中不包含 BusinessId ，且 Session 中不包含 BusinessId 时，验证失败。
    // 情况2：当 URL 中不包含 BusinessId ，但 Session 中包含 BusinessId 时，验证通过。
    // 情况3：当 URL 中包含 BusinessId，且 Session 中也包含 BusinessId，且两者相等时，验证通过。
    // 其他情况，需要进行验证
    console.log("开始进行授权验证!");
    let queryObj = util.getQueryObject(to.fullPath);

    if (!(queryObj && queryObj.BusinessID)) {
      next({ path: '/login' }); //授权失败 - 参数错误
      return;
    }

    // 判断如果是微信浏览器
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      queryObj.isWxAuth = 1;
    } else {
      queryObj.isWxAuth = 0;
    }

    console.log(queryObj);

    store.dispatch('Login', queryObj).then(res => {
      if (res.code !== 1) {
        console.log("授权失败");
        if (res.code === 5007) {
          next({ path: '/noPermission' });
          return;
        }

        Vue.$vux.toast.show('授权失败');
        next({ path: '/login' })
      } else {
        console.log("57====", Cookies.get(UPDATE_TOKEN))
        console.log("授权成功");
        // Vue.$vux.toast.show('授权成功');

        // 判断如果是微信浏览器
        if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {

          // 注释掉，由于走了getinfo，如果不走微信回调，会导致token刷新但无法匹配到userid
          // const CookieBusinessID = Cookies.get('CookieBusinessID') || '';
          // if(CookieBusinessID === queryObj.BusinessID){
          //   next({path: '/'});
          //   return;
          // }

          // 开始微信授权
          store.dispatch('WeChatOAuth').then(res => {
            if (res.code !== 1) {
              console.log("微信授权异常");
              Vue.$vux.toast.show("微信授权异常");
              next({ path: '/login' });
              return;
            }
            let inFifteenMinutes = new Date(new Date().getTime() + 20 * 60 * 60 * 1000);
            const cookiesExpire = { expires: inFifteenMinutes };
            Cookies.set('CookieBusinessID', queryObj.BusinessID, cookiesExpire);
            // 生成授权成功，页面跳转
            location.href = res.data;
            // next({path: res.data});
            next();
          }).catch(err => {
            console.log("微信授权异常");
            Vue.$vux.toast.show("链接超时，请刷新尝试");
            next({ path: '/login' });
          });
        } else if (isInsideWallet) {
          store.dispatch('UnionPayOAuth').then(res => {
            if (res.code !== 1) {
              store.dispatch('UnionPayOAuth').then(res => {
                if (res.code !== 1) {
                  console.log("云闪付授权异常");
                  Vue.$vux.toast.show("云闪付授权异常");
                  next({ path: '/login' });
                  return;
                }
              })
            }

            const stData = {
              time: new Date().getTime(),
              flag: true
            };
            window.localStorage.setItem(UNION_PAY_AUTH_FLAG, JSON.stringify(stData));
            location.href = res.data;
            next();
          }).catch(err => {
            console.log("云闪付授权异常");
            Vue.$vux.toast.show("云闪付授权异常");
            next({ path: '/login' });
          })
        } else {
          if (queryObj.BackUrl) {
            //非微信浏览器
            next({ path: queryObj.BackUrl });
          } else {
            //非微信浏览器
            next({ path: '/' });
          }
        }
      }
    }).catch(err => {
      console.log("授权异常");
      Vue.$vux.toast.show("链接超时，请刷新尝试");
      next({ path: '/login' });
    });
  }

  // 判断是否有token
  else if (store.getters.token) {
    console.log(store.getters.token, '授权信息', store.getters.openId);
    if (to.path === "/login") { // 在免授权白名单，直接进入
      next();
      return;
    }

    let roles = store.getters.roles;
    if (!(roles && roles.length > 0)) {
      // 不存在角色名，则跳转至授权页面
      next('/auth' + params);
      return;
    }


    if (store.getters.addRouters.length === 0) {
      // 生成可访问的路由表
      store.dispatch('GenerateRoutes', { roles }).then(() => {

        console.log("输出动态路由", store.getters.addRouters)

        // 动态添加可访问路由表
        router.addRoutes(store.getters.addRouters);

        store.dispatch('getNowRoutes', to);

        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        if (hasPermission(roles, to.meta.role)) {
          console.log("has permission");
          // next();
          next({ ...to, replace: true });
        } else {
          console.log("has no permission");
          next({ path: '/', query: { noGoBack: true } });
        }
      });
    } else {

      store.dispatch('getNowRoutes', to);

      // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
      if (hasPermission(store.getters.roles, to.meta.role)) {
        next();
      } else {
        next({ path: '/', query: { noGoBack: true } });
      }
    }
  } else if (to.query.token) {
    console.log("159==", to);
    // 当前登录授权的登录token
    let querytoken = to.query.token;
    Cookies.set(UPDATE_TOKEN, querytoken, { expires: 0 });
    // 设置权限
    Cookies.set(UPDATE_ROLES, JSON.stringify(['default']), { expires: 0 });

    let roles = ['default'];

    if (store.getters.addRouters.length === 0) {
      // 生成可访问的路由表
      store.dispatch('GenerateRoutes', { roles }).then(() => {

        console.log("输出动态路由", store.getters.addRouters);

        // 动态添加可访问路由表
        router.addRoutes(store.getters.addRouters);

        store.dispatch('getNowRoutes', to);

        next({ ...to, replace: true });
      });
    } else {

      store.dispatch('getNowRoutes', to);

      next();
    }

  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免授权白名单，直接进入
      next();
    } else {
      console.log('请授权!');
      // 否则全部重定向到授权页
      next('/auth' + params);
    }
  }
});


// permissiom judge
function hasPermission(roles, permissionRoles) {
  if (roles.indexOf('default') >= 0) return true; // default权限 直接通过
  if (!permissionRoles) return true;
  return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

router.afterEach(() => {
  NProgress.done() // 结束Progress
});


// router.beforeEach((to, from, next) => {
//   let allowBack = true    //    给个默认值true
//   if (to.meta.allowBack !== undefined) {
//     allowBack = to.meta.allowBack
//   }
//   if (!allowBack) {
//     history.pushState(null, null, location.href)
//   }
//   store.dispatch('updateAppSetting', {     //   updateAppSetting 只是store里面的一个action， 用来改变store里的allowBack的值的，具体怎么改这个值 要根据各位的实际情况而定
//     allowBack: allowBack
//   })
// });


import { isAndroid } from './utils/isAndroid'
import { getWxConfig, wxShare } from './utils/wechatConfig'
// import {getUpsdkConfig} from './utils/upsdkConfig'

const shareWhiteList = ['/order_list', '/order_detail', '/cashier', '/aliMiddle', '/detail', '/index']; // 分享白名单
router.afterEach((to, from) => {
  /** 这段是我判断项目正式服和测试服路径的代码，请根据实际拼接自己项目链接路径 **/
  let FRONT_BASE = `${location.protocol}//${location.host}`;
  let url = FRONT_BASE + to.fullPath;

  if (window.entryUrl === '' || window.entryUrl === undefined || window.entryUrl === null) {
    window.entryUrl = url;
  }

  // 判断如果是微信浏览器
  if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
    // if (shareWhiteList.indexOf(to.path) !== -1) {
    if (isAndroid()) {
      // 非ios设备，切换路由时候进行重新签名
      getWxConfig(url);
      wxShare(url);
    } else {
      getWxConfig(window.entryUrl);
      wxShare(window.entryUrl);
    }
    // }else{
    //   if (isAndroid()) {
    //     // 非ios设备，切换路由时候进行重新签名
    //     getWxConfig(url);
    //     wxShare(url,'blackList');
    //   } else {
    //     getWxConfig(window.entryUrl);
    //     wxShare(window.entryUrl,'blackList');
    //   }
    // }
  }
  // //判断是否在云闪付APP内
  // let agent = navigator.userAgent.toLowerCase();
  // let isInsideWallet = ((new RegExp(/(com.unionpay.chsp)/).test(agent)) || (new RegExp(/(com.unionpay.mobilepay)/).test(agent)));
  // if(isInsideWallet) {
  //   if (isAndroid()) {
  //     // 非ios设备，切换路由时候进行重新签名
  //     getUpsdkConfig(url);
  //   } else {
  //     getUpsdkConfig(window.entryUrl);
  //   }
  // }

  if (window.entryTitle === '' || window.entryTitle === undefined || window.entryTitle === null || document.title.indexOf('支付宝') !== -1) {
    window.entryTitle = to.meta.title;
  }
  if (isAndroid()) {
  } else {
    document.title = window.entryTitle;
  }
});



// WEBPACK FOOTER //
// ./src/oauth.js